import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Button from '../Button';
import styles from './style.module.css';

/*
  Bentuk/format input options yang di passing (array biasa):
  ["Upstream","Refining & Petrochemical","Commercial & Trading","Power & NRE","Gas"]
  ['Item 1','Item 2','Item 3']
  [1.2.3.4.5]
*/

export default function InputDropdown(props) {
  const {
    // mandatory props
    name,
    label,
    options,

    // secondary props
    setInputValue,

    // optional props
    className,
    defaultValue,
    placeholder = 'Pilih Opsi',
    required,
    disabled,
    useNameForValue = false,
    optionList,
    value,
    alertMessage,
    // alertMessage = 'Tidak boleh kosong, harus diisi',

    // grouped props (1), icon button must FontAwesome & facircle
    onAdditionalButtonClick,
    iconButton,
    // grouped props (1) optional
    description,
  } = props;

  const classes = [styles.root, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {label && (
        <>
          <label htmlFor={name}>
            {label} <span className={styles.doubleColonMobile}> :</span>
          </label>
          <span className={styles.doubleColon}>:</span>
        </>
      )}
      <div className={styles.inputWrapper}>
        <select
          id={name}
          name={name}
          required={required}
          onChange={(e) => setInputValue && setInputValue(e.target.value)}
          defaultValue={defaultValue ? defaultValue : ''}
          disabled={disabled}
          className={onAdditionalButtonClick && styles.withAdditionalBtn}
        >
          <option disabled value="">
            {placeholder}
          </option>
          {options &&
            options.map((option, index) => (
              <option key={`dropdown-item-${name}-${index}`} value={option}>
                {option}
              </option>
            ))}
          {options && options.length === 0 && (
            <option disabled>data kosong</option>
          )}
        </select>
        {onAdditionalButtonClick && (
          <FontAwesomeIcon
            icon={iconButton}
            className={`${styles.additionalBtn} noselect`}
            onClick={() =>
              description
                ? onAdditionalButtonClick(description)
                : onAdditionalButtonClick()
            }
          />
        )}
      </div>
      {required && alertMessage && (
        <>
          <div></div>
          <div></div>
          <div className={styles.inputAlert}>
            <FontAwesomeIcon icon={faTriangleExclamation} />
            {` `}&nbsp;
            <span>{alertMessage}</span>
          </div>
        </>
      )}
    </div>
  );
}
